module.exports = __webpack_public_path__ + "media/images/ohap_courseware_laptop-68b7da3ea44397507be0ab4b3fd45b36.png";